export const slugifyHelper = (text) => {
  if (typeof text === "object" && text && text.name) {
    text = text.name;
  }
  if (typeof text !== "string") return "";
  return text
    .toLowerCase()
    .replace(/[^0-9a-z\u0600-\u06FF]/gi, "-")
    .replace(/-{1,}/g, "-")
    .replace(/-$/, "");
};